import { render, staticRenderFns } from "./previous-step-button.vue?vue&type=template&id=0890d894&scoped=true"
import script from "./previous-step-button.ts?vue&type=script&lang=ts&external"
export * from "./previous-step-button.ts?vue&type=script&lang=ts&external"
import style0 from "./previous-step-button.scss?vue&type=style&index=0&id=0890d894&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890d894",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
